<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p>应用菜单管理</p>
    </div>
    <div class="main-body">
      <el-form
        size="mini"
        :inline="true"
        :model="params"
        class="demo-form-inline"
      >
        <el-form-item label="平台类型">
          <el-select v-model="params.platformType" placeholder="请选择平台类型">
            <el-option label="web应用" value="3"></el-option>
            <el-option label="ios应用" value="1"></el-option>
            <el-option label="android应用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="w100" type="primary" @click="handleQuery"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button class="w100" type="primary" @click="handleAdd"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="recordList"
        style="width: 100%;margin-bottom: 20px;"
        cell-class-name="text-center"
        row-key="number"
        :tree-props="{ children: 'subMenuList', hasChildren: 'true' }"
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          prop="number"
          label="编号"
          width="230"
        ></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="path" label="路径"></el-table-column>
        <el-table-column label="图标">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="mini"
              >编辑</el-button
            >
            <el-button @click="handleDelete(scope.row)" type="text" size="mini"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="opearteType == '1' ? '新增认证信息' : '编辑认证信息'"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <el-form ref="form" :model="editRecord" label-width="80px">
        <el-form-item label="平台类型">
          <el-select
            v-model="editRecord.platformType"
            placeholder="请选择平台类型"
            @change="queryRecordList(editRecord.platformType, null)"
          >
            <el-option label="web应用" value="3"></el-option>
            <el-option label="ios应用" value="1"></el-option>
            <el-option label="android应用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级菜单">
          <el-cascader
            v-model="editRecord.parentMenuNos"
            :options="menuOptions"
            :props="{
              checkStrictly: true,
              value: 'number',
              label: 'name',
              children: 'subMenuList',
            }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            v-model="editRecord.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="路径">
          <el-input
            v-model="editRecord.path"
            placeholder="请输入路径"
          ></el-input>
        </el-form-item>
        <el-form-item label="图标">
          <el-input
            v-model="editRecord.icon"
            placeholder="请输入图标名称"
            :suffix-icon="editRecord.icon"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input
            v-model="editRecord.sort"
            placeholder="请输入排序"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "applicationMenuMgmt",
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      recordList: [],
      dialogTableVisible: false,
      opearteType: "",
      item: {},
      platformType: "1",
      parentMenuNo: "",
      params: {
        platformType: "3",
      },
      editRecord: {},
      menuOptions: [],
      loading: false,
      loadingText: "数据加载中...",
    };
  },
  mounted() {
    this.queryRecordList(this.params.platformType, "1");
  },
  methods: {
    queryRecordList(platformType, type) {
      let self = this;
      let params = {
        platformType: platformType || "3",
        recursion: true,
      };
      self.loading = true;
      this.$http
        .get(
          "/admin/application/menu/findByParentMenuNoAndPlatformType?" +
            this.$qs.stringify(params),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          if (type == "1") {
            self.recordList = res.ldata;
          } else {
            self.menuOptions = res.ldata;
          }
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    handleAdd: function() {
      this.opearteType = "1";
      this.editRecord = { platformType: this.params.platformType };
      this.menuOptions = [];
      if (this.params.platformType) {
        this.queryRecordList(this.params.platformType, null);
      }
      this.dialogTableVisible = true;
    },

    onSubmit: function() {
      this.createOrUpdate();
    },

    createOrUpdate: function() {
      let self = this;
      if (self.editRecord.parentMenuNos) {
        self.editRecord.parentMenuNo =
          self.editRecord.parentMenuNos[
            self.editRecord.parentMenuNos.length - 1
          ];
      }
      console.log(self.editRecord);
      this.$http
        .get(
          "/admin/application/menu/createOrUpdate?" +
            this.$qs.stringify(self.editRecord),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.closeDialog();
          self.queryRecordList(self.params.platformType, "1");
        })
        .catch(function(response) {
          console.log(response);
        });
    },
    closeDialog: function() {
      this.dialogTableVisible = false;
      this.item = {};
    },
    handleEdit: function(row) {
      this.opearteType = "2";
      this.dialogTableVisible = true;
      this.menuOptions = [];
      if (this.params.platformType) {
        this.queryRecordList(this.params.platformType, null);
      }
      this.editRecord = JSON.parse(JSON.stringify(row));
      this.editRecord.parentMenuNos = [this.editRecord.parentMenuNo];
    },

    handleDelete(item) {
      this.$confirm("是否确认删除？").then(() => {
        this.delete(item.number);
      });
    },

    delete(number) {
      let self = this;
      let params = {
        number: number,
      };
      this.$http
        .get("/admin/application/menu/delete?" + this.$qs.stringify(params), {
          headers: { token: this.token },
        })
        .then(function(response) {
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.queryRecordList(self.params.platformType, "1");
        })
        .catch(function(response) {
          console.log(response);
        });
    },

    handleQuery() {
      this.beginIndex = 0;
      this.queryRecordList(this.params.platformType, "1");
    },
    showErrorMessage(message) {
      if (message == "0000") {
        this.$message({
          type: "warning",
          message: "请先登录",
          center: true,
        });
      } else if (message == "0001") {
        this.$message({
          type: "warning",
          message: "未认证",
          center: true,
        });
      } else if (message == "0002") {
        this.$message({
          type: "warning",
          message: "无权限",
          center: true,
        });
      } else {
        this.$message({
          type: "error",
          message: message,
          center: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-200 {
      width: 200px;
    }

    .fixed-width-300 {
      width: 300px;
    }

    .fixed-width-400 {
      width: 400px;
    }
  }

  .table-custom {
    border-bottom: 1px solid #cdcdcd;
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #4949ff;
      display: inline-block;
      background-color: #67aff6;
      cursor: pointer;
    }

    .text-btn.disabled {
      border: #67aff6;
      background-color: #fff;
      cursor: default;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-300 {
      width: 300px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applicationMenuMgmt.vue